var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(-275 -482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar-2",
    "data-name": "calendar",
    transform: "translate(275 482)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 18,
    height: 18,
    rx: 2,
    transform: "translate(3 4)",
    fill: "none",
    stroke: "#1c2023",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y2: 4,
    transform: "translate(16 2)",
    fill: "none",
    stroke: "#1c2023",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    y2: 4,
    transform: "translate(8 2)",
    fill: "none",
    stroke: "#1c2023",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 18,
    transform: "translate(3 10)",
    fill: "none",
    stroke: "#1c2023",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 24,
    height: 24,
    transform: "translate(275 482)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.63d59a76bc5a572ee02c8ca14e7de8ed.svg";
export { ForwardRef as ReactComponent };